export const CATEGORY_TYPE = 'category';
export const CONFLICT_ERROR = 'conflict';
export const PAGE_EXISTS_CONFLICT_ERROR = 'PAGE_EXISTS';
export const BLOG_EXISTS_CONFLICT_ERROR = 'BLOG_EXISTS';
export const REDIRECT_EXISTS_CONFLICT_ERROR = 'REDIRECT_EXISTS';
export const CATEGORY_TRANSLATION_NAME_CONFLICT = 'CATEGORY_TRANSLATION_NAME_CONFLICT';
export const CONFLICT_ERRORS = [PAGE_EXISTS_CONFLICT_ERROR, BLOG_EXISTS_CONFLICT_ERROR, REDIRECT_EXISTS_CONFLICT_ERROR, CATEGORY_TRANSLATION_NAME_CONFLICT];
export const MAX_LENGTH = 100;
export const MAX_DESCRIPTION_LENGTH = 150;
export const OPTIONAL_FIELD = 'optional';
export const RECOMMENDED_LENGTH = 60;
export const REQUIRED_FIELD = 'required';
export const SUB_CATEGORY_TYPE = 'subcategory';
export const UNKNOWN_ERROR = 'unknown';
export const EDIT_ACTION = 'edit';
export const ADD_ACTION = 'add';
export const CATEGORY_NAME_EMPTY = 'CATEGORY_NAME_EMPTY';